import { clearAdminToken } from '@/utils/auth';

const LOGIN_PATH = '/user/login';

/** 避免短时间内多次触发跳转 */
let redirecting = false;

/**
 * 登录失效：清 token、提示（可选）、跳转登录页。
 * 使用整页跳转以清空 Umi initialState / 布局缓存中的 currentUser，避免「有用户但无 token」的卡死状态。
 */
export function redirectToLogin(opts?: { reason?: string; silent?: boolean }) {
  if (typeof window === 'undefined') return;
  if ((globalThis as any).__LOGIN_DISABLED__ === true) return;
  if (redirecting) return;
  redirecting = true;

  clearAdminToken();

  const reason = opts?.reason?.trim() || '登录已失效，请重新登录';
  if (!opts?.silent) {
    try {
      sessionStorage.setItem('znt_login_message', reason);
    } catch (_e) {
      // ignore
    }
  }

  const loginUrl = `${window.location.origin}${LOGIN_PATH}`;
  try {
    window.location.replace(loginUrl);
  } catch (_e) {
    window.location.href = loginUrl;
  }

  setTimeout(() => {
    redirecting = false;
  }, 3000);
}

export function isLoginPath(pathname: string) {
  return (
    pathname === LOGIN_PATH ||
    pathname.startsWith('/user/register') ||
    pathname.startsWith('/user/register-result')
  );
}

/**
 * 判断是否为「需重新登录」类错误（HTTP 401、业务码 401、ensureCodeOk 抛出的 err.code）
 */
export function isUnauthorizedError(error: any): boolean {
  if (!error) return false;

  const code = error.code ?? error?.response?.data?.code ?? error?.data?.code;
  if (code === 401 || code === '401') return true;

  const status = error.response?.status ?? error?.response?.statusCode;
  if (status === 401) return true;

  const rawMsg =
    error?.response?.data?.msg ||
    error?.response?.data?.message ||
    error?.data?.msg ||
    error?.data?.message ||
    error?.message ||
    '';
  const msg = String(rawMsg).toLowerCase();
  if (
    msg.includes('token无效') ||
    msg.includes('token已过期') ||
    msg.includes('token 失效') ||
    msg.includes('token过期') ||
    msg.includes('登录失效') ||
    msg.includes('登录已失效') ||
    msg.includes('unauthorized') ||
    msg.includes('invalid token') ||
    msg.includes('token expired')
  ) {
    return true;
  }

  return false;
}

/**
 * Axios 成功响应里常见的 { code: 401, msg } 结构
 */
export function isUnauthorizedResponseData(data: any): boolean {
  if (!data || typeof data !== 'object') return false;
  const c = (data as any).code;
  if (c === 401 || c === '401') return true;

  const msg = String((data as any).msg ?? (data as any).message ?? '').toLowerCase();
  if (
    msg.includes('token无效') ||
    msg.includes('token已过期') ||
    msg.includes('token 失效') ||
    msg.includes('token过期') ||
    msg.includes('登录失效') ||
    msg.includes('登录已失效') ||
    msg.includes('unauthorized') ||
    msg.includes('invalid token') ||
    msg.includes('token expired')
  ) {
    return true;
  }
  return false;
}

export { LOGIN_PATH };
